<template>
  <SdsDatepicker
    :id="dataset['id'] ?? null"
    v-model="model"
    :name="dataset['name'] ?? null"
    :class="dataset['class'] ?? null"
    :min="dataset['min'] ?? min"
    :max="dataset['max'] ?? max"
    :disabled="dataset['disabled'] === 'false' ? false : true"
    :readonly="dataset['readonly'] === 'false' ? false : true"
    :invalid="false"
    :valid="false"
    :mode="dataset['mode'] ?? 'date'"
    :size="dataset['size'] ?? 'md'"
  />
</template>

<script setup lang="ts">
import { inject, ref } from 'vue'
const dataset = inject('dataset')

defineOptions({
  name: "GenericDatepicker"
})

// Default min 1987
const min = new Date('1987-01-01');
// Default max +5 years
const max = new Date(new Date().getTime() + (5*12*4*7*24*60*60*1000));

const model = dataset['model'] ? ref(new Date(dataset['model'])) : ref();
</script>
